import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import StripeCheckout from 'react-stripe-checkout';

import Button from '../../../../../../../../components/global/Button';
import getConfig from '../../../../../../../../util/config';
import { getAsset } from '../../../../../../../../util/assets';
import { formatPriceForDisplay } from '../../../../../../../../util/format-money';
import { getRecipientFirstName } from '../../helpers';

const propTypes = {
  recipients: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  ),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onCardSend: PropTypes.func.isRequired,
  className: PropTypes.string,
  price: PropTypes.shape({
    total_price: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }).isRequired,
    requires_payment: PropTypes.bool.isRequired,
  }),
};

const CardSendButton = ({
  className,
  loading,
  disabled,
  onCardSend,
  price,
  recipients = [],
}) => {
  const classes = classNames({
    [className]: !!className,
  });
  const config = getConfig();
  const totalPrice = price?.total_price?.value;

  return (
    <StripeCheckout
      name="Waldo Photos"
      description="Cards Checkout"
      image={getAsset('/waldo-stripe-logo.png')}
      token={token => onCardSend(token)}
      panelLabel={`Pay $${formatPriceForDisplay(totalPrice)}`}
      stripeKey={config.stripe.key}
      currency="USD"
      ComponentClass="div"
      zipCode
      disabled={disabled}
    >
      <Button
        className={classes}
        btnBlock
        disabled={disabled}
        loading={loading}
        onClick={event => {
          if (!price?.requires_payment) {
            event.preventDefault();
            event.stopPropagation();
            onCardSend();
          }
        }}
      >
        {loading ? (
          'Sending...'
        ) : (
          <Fragment>
            {recipients.length === 1 &&
              `Send to ${getRecipientFirstName(recipients[0].name)}`}
            {recipients.length > 1 && `Send ${recipients.length} Cards`}
          </Fragment>
        )}
      </Button>
    </StripeCheckout>
  );
};

CardSendButton.propTypes = propTypes;

export default CardSendButton;
